import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';
import { mapPedidoSearch } from '@/libs/pedidoSearch';

export default class SLS_pedidosVendas {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  sanitizeParams(params) {
    if (!params || typeof params !== 'object') return undefined;
    const cleaned = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v === undefined || v === null) return;
      if (typeof v === 'number' && isNaN(v)) return;
      if (v === '') return;
      cleaned[k] = v;
    });
    return Object.keys(cleaned).length ? cleaned : undefined;
  }

  getUserId() {
    try {
      // Aceita os dois formatos do localStorage 'userData' (plano ou embrulhado)
      const userData = JSON.parse(localStorage.getItem('userData'));
      return userData?.id || userData?.userData?.id || null;
    } catch (error) {
      return null;
    }
  }

  async getPedidosVendas(params) {
    try {
      params = mapPedidoSearch(params, 'prePedido', 'pedidoErp');
      const userId = this.getUserId();
      let url = '/pedido-venda/listar';

      if (params && params.perfilTipo && params.perfilId) {
        url = `/pedido-venda/listar/${params.perfilTipo}/${params.perfilId}/${userId}`;

        const { perfilTipo, perfilId, ...queryParams } = params;
        params = queryParams;
      }

      const response = await this.api.get(url, { params });
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
      throw error;
    }
  }

  async getRascunhosPedidosVendas(params) {
    try {
      params = mapPedidoSearch(params, 'prePedido', 'pedidoErp');
      const userId = this.getUserId();
      let url = '/pedido-venda/listarRascunhos';

      if (params && params.perfilTipo && params.perfilId) {
        url = `/pedido-venda/listarRascunhos/${params.perfilTipo}/${params.perfilId}/${userId}`;

        const { perfilTipo, perfilId, ...queryParams } = params;
        params = queryParams;
      }

      const response = await this.api.get(url, { params });
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async listarCapaPedido(pedidoid) {
    try {
      const response = await this.api.get(`pedido-venda/listarCapaPedido/${pedidoid}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async cancelarPedido(pedidoid) {
    try {
      const response = await this.api.post(`pedidos/cancelar/${pedidoid}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async salvarItens(data) {
    // console.log(data);
    try {
      const response = await this.api.post('pedidos/editarItensPedidoVenda', {
        dataPedido: data.dataPedido,
        itens: data.itens,
      });
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async enderecoEntregaPedido(clienteid) {
    try {
      const response = await this.api.get(`pedido-venda/enderecoEntrega/${clienteid}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async itensPedido(pedidoid, filters) {
    try {
      const sanitized = this.sanitizeParams(filters);
      const config = sanitized ? { params: sanitized } : undefined;
      const response = await this.api.get(`pedido-venda/itens/${pedidoid}`, config);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async itensMarcaPedido(precoId) {
    try {
      const response = await this.api.get(`pedido-venda/marca/${precoId}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async itensCategoriaPedido(cod_marca) {
    try {
      const response = await this.api.get(`pedido-venda/categoria/${cod_marca}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async itensReferenciaPedido(codmarca, codcategoria, tipopedidoid, clienteid, precoId = null) {
    try {
      const qs = new URLSearchParams();
      if (tipopedidoid) qs.set('tipopedidoid', tipopedidoid);
      if (clienteid) qs.set('clienteid', clienteid);
      if (precoId) qs.set('precoId', precoId);
      const query = qs.toString();
      const response = await this.api.get(`pedido-venda/referencia/codmarca/${codmarca}/codCategoria/${codcategoria}${query ? `?${query}` : ''}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async itensEmbalagemPedido(fml_comercialId, precoId) {
    try {
      const response = await this.api.get(`pedido-venda/embalagem/${fml_comercialId}/precoId/${precoId}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async itensImagemPedido(codmarca, familia_comercial) {
    try {
      const response = await this.api.get(`pedido-venda/imagens/${codmarca}/familia_comercial/${familia_comercial}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async precoItemPedido(tabelaPrecoId, item) {
    try {
      const response = await this.api.get(`tabela-preco-item/tabelapreco/${tabelaPrecoId}/item/${item}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async ItemPedido(cod_marca, cod_categ, familia_comercial) {
    try {
      const response = await this.api.get(`pedido-venda/item-pedido/cod-marca/${cod_marca}/cod-categ/${cod_categ}/familia-comercial/${familia_comercial}`);
      return response.data;
    } catch (error) {
      this.error.message(error);
    }
  }

  async buscarReferenciaPorCodigo(codReferencia, tabelaPrecoId, tipopedidoid, clienteid) {
    try {
      const params = new URLSearchParams();
      if (tipopedidoid) params.set('tipopedidoid', tipopedidoid);
      if (clienteid) params.set('clienteid', clienteid);
      const qs = params.toString();
      const response = await this.api.get(`/pedido-venda/referencia/buscar/${codReferencia}/precoId/${tabelaPrecoId}${qs ? `?${qs}` : ''}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async listarFiltrosItens(tabelaPrecoId) {
    try {
      const response = await this.api.get(`/pedido-venda/referencia/filtros/precoId/${tabelaPrecoId}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async buscarReferenciasComFiltros(tabelaPrecoId, params = {}) {
    try {
      const qs = Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null && String(v).trim() !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const response = await this.api.get(`/pedido-venda/referencia/buscar-filtros/precoId/${tabelaPrecoId}${qs ? `?${qs}` : ''}`);
      return response.data;
    } catch (error) {
      this.error.errorShow(error);
    }
  }

  async analisarImportacaoCsv(precoId, itens) {
    const response = await this.api.post('/pedido-venda/importar-csv/analisar', { precoId, itens });
    return response.data;
  }
}
